/**
 * Hustle & Hound — Engraving Add-On Cart Logic
 * 
 * Hooks into Dawn v15's product-form-component to intercept
 * the Add-to-Cart action and bundle the $15 Engraving variant
 * alongside the main Collar variant using the Shopify AJAX Cart API.
 */
(function () {
    'use strict';

    // Wait for DOM
    document.addEventListener('DOMContentLoaded', init);

    function init() {
        var checkbox = document.getElementById('hh-engraving-checkbox');
        var fields = document.getElementById('hh-engraving-fields');
        var line1 = document.getElementById('hh-engraving-line1');
        var line2 = document.getElementById('hh-engraving-line2');

        if (!checkbox || !fields) return;

        // --- 1. Toggle visibility of the engraving text fields ---
        checkbox.addEventListener('change', function () {
            if (checkbox.checked) {
                fields.classList.add('is-visible');
            } else {
                fields.classList.remove('is-visible');
                if (line1) line1.value = '';
                if (line2) line2.value = '';
            }
        });

        // --- 2. Intercept the product form submission ---
        // Dawn v15 uses <product-form-component> which wraps a standard 
        // Liquid {% form 'product' %} tag. The form action is /cart/add.
        // We need to find that form and intercept its submit event.

        // Try multiple selectors to find the Dawn product form
        var productForm = document.querySelector('form[action*="/cart/add"]')
            || document.querySelector('[data-type="add-to-cart-form"]')
            || document.querySelector('product-form-component form');

        if (!productForm) {
            console.warn('[HH Engraving] Could not find product form. Engraving bundling disabled.');
            return;
        }

        console.log('[HH Engraving] Successfully hooked into product form:', productForm);

        // Listen to the submit event on the form
        productForm.addEventListener('submit', function (e) {
            // Only intercept if the engraving checkbox is checked
            if (!checkbox.checked) return; // Let Dawn handle it normally

            var engravingVariantEl = document.getElementById('hh-engraving-variant-id');
            var engravingVariantId = engravingVariantEl ? engravingVariantEl.value : '';

            if (!engravingVariantId) {
                console.warn('[HH Engraving] No engraving variant ID found. Falling back to standard submit.');
                return; // Let Dawn handle it normally
            }

            // Prevent Dawn's default form submission
            e.preventDefault();
            e.stopPropagation();

            // Get the main product variant ID from the hidden input in the form
            var variantInput = productForm.querySelector('input[name="id"]');
            var mainVariantId = variantInput ? variantInput.value : null;

            if (!mainVariantId) {
                console.error('[HH Engraving] Could not find main variant ID.');
                return;
            }

            // Get quantity
            var qtyInput = productForm.querySelector('input[name="quantity"]');
            var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
            if (!quantity || quantity < 1) quantity = 1;

            // Build the multi-item payload
            var items = [
                {
                    id: parseInt(mainVariantId, 10),
                    quantity: quantity,
                    properties: {
                        'Engraving Line 1': line1 ? line1.value : '',
                        'Engraving Line 2': line2 ? line2.value : ''
                    }
                },
                {
                    id: parseInt(engravingVariantId, 10),
                    quantity: quantity
                }
            ];

            console.log('[HH Engraving] Submitting multi-item payload:', JSON.stringify(items));

            // Disable button while processing
            var submitBtn = productForm.querySelector('button[type="submit"], [type="submit"]');
            if (submitBtn) {
                submitBtn.setAttribute('disabled', 'disabled');
                submitBtn.setAttribute('aria-disabled', 'true');
            }

            // Use the Shopify AJAX Cart API
            var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
                ? window.Shopify.routes.root
                : '/';

            fetch(rootUrl + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
            })
                .then(function (response) {
                    if (!response.ok) {
                        return response.json().then(function (err) {
                            throw new Error(err.description || err.message || 'Cart add failed');
                        });
                    }
                    return response.json();
                })
                .then(function (data) {
                    console.log('[HH Engraving] Successfully added to cart:', data);
                    // Redirect to cart page
                    window.location.href = rootUrl + 'cart';
                })
                .catch(function (error) {
                    console.error('[HH Engraving] Error adding to cart:', error);
                    alert('There was an error adding items to your cart: ' + error.message);
                    // Re-enable the button
                    if (submitBtn) {
                        submitBtn.removeAttribute('disabled');
                        submitBtn.removeAttribute('aria-disabled');
                    }
                });
        });
    }
})();
